import { render } from "./PlatformNode.vue?vue&type=template&id=09254db1&ts=true"
import script from "./PlatformNode.vue?vue&type=script&lang=ts"
export * from "./PlatformNode.vue?vue&type=script&lang=ts"

import "./PlatformNode.vue?vue&type=style&index=0&id=09254db1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__